module.exports = __webpack_public_path__ + "static/slide2-318x245-9712995a697d1c2f3daf6652fca907b8.gif";